import Plugin from '../Plugin'

import SeasonPassClient from '@engine/seasonPass/SeasonPassClient'

export default class SeasonPass extends Plugin {

    constructor(network) {
        super(network)

        if (this.game.seasonPass instanceof SeasonPassClient) {
            this.client = this.game.seasonPass
        } else {
            this.client = new SeasonPassClient(this.game, this.network)
            this.game.seasonPass = this.client
        }

        this.events = {
            'load_player': this.handleLoadPlayer.bind(this),
            'season_pass_state': this.handleState.bind(this),
            'season_pass_progress_update': this.handleProgress.bind(this),
            'season_pass_task_update': this.handleTasks.bind(this),
            'season_pass_reward_claimed': this.handleRewardClaim.bind(this),
            'season_pass_error': this.handleError.bind(this)
        }
    }

    handleLoadPlayer() {
        this.client.handleLoginBootstrap()
    }

    handleState(payload) {
        this.client.updateState(payload)
    }

    handleProgress(payload) {
        this.client.updateProgress(payload)
    }

    handleTasks(payload) {
        this.client.updateTasks(payload)
    }

    handleRewardClaim(payload) {
        this.client.handleRewardClaim(payload)
    }

    handleError(payload) {
        this.client.handleError(payload)
    }

}
